import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, EditableItem, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_SmartNote.scss';
import { Component_SmartNoteSection } from './Component_SmartNoteSection.js';
import { FadeScrollWrapper } from '@app/styles';
import { ModuleFE_EMInterface, ModuleFE_RuntimeSmartNote } from '@app/advisor-frontend';
import { ModuleFE_Notes } from '../../../modules/ModuleFE_Notes/ModuleFE_Notes.js';
export class Component_SmartNote extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.note = nextProps.note instanceof EditableItem ? nextProps.note : this.getEditable(nextProps.note);
        this.setEditableProps(state.note);
        state.editMode = !!nextProps.editMode;
        state.asTextBlob = !!nextProps.asTextBlob;
        return state;
    }
    //######################### Logic #########################
    getEditable(note) {
        return new EditableItem(note).setSaveAction(async (note) => note);
    }
    setEditableProps(editable) {
        editable.setOnChanged(async (note) => this.forceUpdate());
    }
    getClassName = () => {
        return _className('smart-note', this.state.editMode && 'edit-mode');
    };
    //######################### Render #########################
    render() {
        return _jsxs(FadeScrollWrapper, { className: this.getClassName(), onCopy: () => ModuleFE_Notes.analytics.note.copy(), children: [this.render_Segmented(), this.render_TextBlob()] });
    }
    render_Segmented = () => {
        if (this.state.asTextBlob)
            return;
        return _jsxs(_Fragment, { children: [this.render_Segmented_NoteContent(), this.render_Segmented_Sections()] });
    };
    render_TextBlob = () => {
        if (!this.state.asTextBlob)
            return;
        const note = this.state.note.item;
        const ignoreSelection = ModuleFE_EMInterface.isAvatarMode();
        return ModuleFE_RuntimeSmartNote.convertNoteToTextBlob(note, ignoreSelection);
    };
    //######################### Render - Segmented #########################
    render_Segmented_NoteContent = () => {
        const note = this.state.note.item;
        if (!note.content)
            return;
        return _jsx("p", { className: 'smart-note__content', children: note.content });
    };
    render_Segmented_Sections = () => {
        const sections = this.state.note.editProp('sections', []);
        if (!sections.item.length)
            return;
        return _jsx(LL_V_L, { className: 'smart-note__sections', children: sections.item.map((section, index) => {
                const editable = sections.editProp(index, {});
                const key = `${this.state.note.item._id}_section_${index}`;
                return _jsx(Component_SmartNoteSection, { section: editable, editMode: this.state.editMode, aiMode: true }, key);
            }) });
    };
}
//# sourceMappingURL=Component_SmartNote.js.map